import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/wedding/Navbar";
import Hero from "@/components/wedding/Hero";
import Journey from "@/components/wedding/Journey";
import Invitation from "@/components/wedding/Invitation";
import Itinerary from "@/components/wedding/Itinerary";
import Gallery from "@/components/wedding/Gallery";
import GuestPhotos from "@/components/wedding/GuestPhotos";
import Logistics from "@/components/wedding/Logistics";
import Rsvp from "@/components/wedding/Rsvp";
import Footer from "@/components/wedding/Footer";
import LocationPrompt from "@/components/wedding/LocationPrompt";
import DirectionsCard from "@/components/wedding/DirectionsCard";
import Admin from "@/components/wedding/Admin";

const Home = () => (
  <div className="App bg-[#FDFBF7] text-[#1A1A1A] antialiased">
    <Navbar />
    <main>
      <Hero />
      <Invitation />
      <Itinerary />
      <Logistics />
      <Journey />
      <Rsvp />
      <Gallery />
      <GuestPhotos />
    </main>
    <Footer />
    <LocationPrompt />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/card" element={<DirectionsCard />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
